// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__LPAdT","btn":"styles_btn__mZpUh","large":"styles_large__KfvpY","normal":"styles_normal__AIx3q","small":"styles_small__i1eaV"};